// src/utils/brandingSync.ts
// Đồng bộ dữ liệu thương hiệu (logo, tên, màu sắc) giữa 2 nơi cùng đọc/ghi
// chung 1 API (/system-api/BrandingConfiguration): trang Brand Management
// và bộ chọn màu trong Theme Customizer (RightSidebar). Sau khi 1 trong 2 nơi
// lưu thành công, gọi hàm này để nơi còn lại (và cache) thấy dữ liệu mới ngay,
// không phải đợi cache hết hạn hoặc reload trang.
import { setConfig } from '../slices/brandingConfiguration/reducer';
import { CacheService, CacheConfig } from '../services/cache';

export const syncBrandingConfig = (dispatch: any, data: any): void => {
  if (!data) return;
  dispatch(setConfig(data));
  CacheService.set(CacheConfig.BRANDING.key, data, CacheConfig.BRANDING.ttl);
};
